module.exports = __webpack_public_path__ + "media/images/icons/menu-open-8c46fdb7387e3ec6091546299711ad4b.svg";